<i *ngIf="!searchTerm && searchBarType !== 'map'" class="icon-search" (click)="changeTerm()"></i>
<i *ngIf="searchTerm && searchBarType !== 'map'" class="icon-error" (click)="clearTerm()"></i>
<i *ngIf="searchBarType === 'map'" class="icon-search left" (click)="openSearchBar(true)"></i>
<input #searchInput
       type="text"
       name="search"
       (blur)="openSearchBar(false)"
       [(ngModel)]="searchTerm"
       (ngModelChange)="changeTerm()"
       placeholder="{{ placeholder | translate }}"
       class="search"
       id="search-field"
       [ngClass]="{ 'condensed': searchBarType === 'map', 'open': searchOpen }"
       autocomplete="off" />
